<template>
  <div class="col-12">
    <div v-for="item in visitDetailList" :key="item.id">
      <div id="board" class="row bg-white board-radius p-2">
        <section
          class="col-md-3 border-right date-container"
          :class="{
            'mb-4 flex justify-content-between': isMobile,
          }"
        >
          <div class="w-100">
            <picture
              class="icon-container"
              :class="{
                'ml-0': isMobile,
              }"
            >
              <img
                v-if="isAbsence(item)"
                src="@/assets/img/icon_square-x.svg"
              />
              <img
                v-else-if="isCyberTeraphy(item)"
                src="@/assets/img/icon_square-v.svg"
              />
              <img v-else src="@/assets/img/icon_square-p.svg" />
            </picture>
            <span class="font-weight-bold date">
              {{ formatDateLong(item) }}
            </span>
          </div>
          <action-button
            v-if="isMobile && isAbsence(item)"
            i="fas fa-edit"
            variant="success mr-3"
          />
        </section>
        <section
          class="col-md"
          :class="{
            'border-top pt-3 mb-2': isMobile,
          }"
        >
          <validation-observer :ref="editingFormRef(item)">
            <div class="row">
              <div class="col-12 col-md-3 content-container mb-2 mb-md-0">
                <label class="data-name">
                  Tipos:
                </label>
                <br />
                <validation-provider
                  v-if="editing(item)"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="absenceModel.type"
                    custom-error-msg="El tipo de ausencia es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="visitTypeOptions"
                    placeholder="Seleccione"
                  />
                </validation-provider>
                <span v-else class="font-weight">
                  {{ visitName(item) }}
                </span>
              </div>
              <div
                v-if="showJustified(item)"
                class="content-container mb-2 mb-md-0"
                :class="{
                  'col-md-5': editing(item),
                  'col-12 col-md': !editing(item),
                }"
              >
                <label class="data-name">
                  Justificación:
                </label>
                <br />
                <validation-provider
                  v-if="editing(item)"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="absenceModel.justification"
                    custom-error-msg="La justificación es requerida."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="justificationOptions"
                    placeholder="Seleccione"
                  />
                </validation-provider>
                <span v-else class="font-weight">
                  {{ item.modelAbsence?.justification?.name }}
                </span>
              </div>
              <div
                v-else-if="showDateReplacement(item) && !editing(item)"
                class="col-12 col-md content-container mb-2 mb-md-0"
              >
                <label class="data-name">
                  Fecha a Reponer:
                </label>
                <br />
                <span class="font-weight">
                  {{ formatDate(item.dateToReplaceVisit) }}
                </span>
              </div>
              <div
                v-else-if="isAbsenceOfReplacementYear(item) && !editing(item)"
                class="col-12 col-md content-container mb-2 mb-md-0"
              >
                <label class="data-name">
                  año anterior
                </label>
                <br />
                <span class="font-weight">
                  {{ item.lastYear }}
                </span>
              </div>
              <div v-else class="col-md content-container" />
              <div
                v-if="showDocument(item)"
                class="col-12 col-md content-container mb-2 mb-md-0"
                :class="{ row: !editing(item) }"
              >
                <div class="d-flex w-100" :class="isMobile && 'ml-3'">
                  <div
                    class="type-document"
                    :class="{
                      'col-12': editing(item),
                      'col-md-10': !editing(item) && !isMobile,
                      'w-100': isMobile,
                    }"
                  >
                    <label class="data-name">Tipo de Documento:</label>
                    <br />
                    <div
                      v-if="showDocumentViewer(item)"
                      class="d-flex align-items-center w-100 justify-content-start"
                    >
                      <label class="mb-0 font-weight-normal">
                        {{ absenceModel.document.name }}
                      </label>
                      <div
                        class="d-flex flex-row-reverse ml-2 button-container"
                      >
                        <action-button
                          variant="outline-danger "
                          @click="quitDocumentSelected"
                        >
                          <i
                            class="fas fa-times-circle"
                            @click="quitDocumentSelected"
                          />
                        </action-button>
                        <action-button
                          variant="outline-success mr-2"
                          @click="
                            downloadDocument({
                              documentId: absenceModel.document.id,
                            })
                          "
                        >
                          <i class="fas fa-file-download" />
                        </action-button>
                      </div>
                    </div>
                    <validation-provider
                      v-else-if="editing(item)"
                      v-slot="{ errors }"
                      rules="required"
                    >
                      <custom-file-input
                        ref="attachedDocument"
                        v-model="absenceModel.document"
                        :accept="'.pdf'"
                        class="pr-3"
                        custom-error-msg="El documento es requerido."
                        display-style="normal"
                        :error="errors[0]"
                        label-position="left"
                        required
                        @after-remove="
                          () => {
                            absenceModel.file = null;
                            absenceModel.documentId = null;
                          }
                        "
                        @input="() => {}"
                      />
                    </validation-provider>
                    <span v-else class="font-weight">
                      {{ item.documentTypeName }}
                    </span>
                  </div>
                  <div v-if="item.documentId" class="px-0 col-sm-2 mt-2">
                    <action-button
                      class="icon-download"
                      i="fas fa-file-download"
                      variant="success"
                      @click="downloadDocument(item)"
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="isAbsenceOfReplacementYear(item) && !editing(item)"
                class="col-md content-container"
              >
                <label class="data-name">Solicitud:</label>
                <br />
                <span class="font-weight">
                  {{ item.request }}
                </span>
              </div>
              <div
                v-if="!isMobile && isAbsence(item)"
                class="col-md-1 content-container"
              >
                <action-button
                  i="fas fa-edit"
                  variant="success float-right"
                  @click="ediVisit(item)"
                />
              </div>
            </div>
            <div v-if="showComment(item)" class="content-container mt-2">
              <label class="data-name">Comentario:</label>
              <br />
              <validation-provider
                v-if="editing(item)"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-input
                  v-model="absenceModel.comment"
                  custom-error-msg="El comentario es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  maxlength="3000"
                  placeholder="Escriba un comentario"
                />
              </validation-provider>
              <span v-else class="font-weight">
                {{ item.modelAbsence?.comment }}
              </span>
            </div>
            <div
              v-if="editing(item)"
              class="d-flex justify-content-end align-items-center my-3"
            >
              <action-button
                id="btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger mr-3 px-3"
                @click="disableEdit"
              />
              <action-button
                id="btnSave"
                i="fas fa-save"
                text="Guardar"
                variant="success px-3"
                @click="saveEdition(item)"
              />
            </div>
          </validation-observer>
        </section>
        <div v-for="error in item.errors" :key="error.id" class="col-sm-12">
          <custom-error class="visit-errors" :message="error.message" />
        </div>
      </div>
    </div>
    <div
      v-if="studentAssistanceDetails.length == 0"
      class="bg-white board-radius p-2"
    >
      <custom-result-not-found />
    </div>
  </div>
</template>

<script>
import visitTypes from '@/utils/constants/visitTypes';
import visitAbsenceTypes from '@/utils/constants/visitAbsenceRegistrationTypes.js';
import moment from 'moment';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomFileInput from '@/components/common/CustomFileInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomResultNotFound from 'custom-result-not-found';
import CustomError from 'custom-error';

export default {
  name: 'AssistanceDetailsRow',
  components: {
    CustomDropDown,
    CustomInput,
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    CustomResultNotFound,
    CustomError,
  },
  props: {
    studentAssistanceDetails: {
      type: Array,
      default: () => [],
    },
    visitTypeOptions: {
      type: Array,
      default: () => [],
    },
    justificationOptions: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      absenceModel: {
        id: null,
        type: null,
        justification: null,
        document: null,
        comment: null,
      },
      hasErrors: true,
    };
  },
  computed: {
    showDocumentViewer() {
      return () => {
        return Boolean(this.absenceModel.documentId);
      };
    },
    visitDetailList() {
      const result = this.studentAssistanceDetails ?? [];
      return result.filter((x) => x.visitDate !== null);
    },
    editing() {
      return ({ id }) => this.absenceModel.id === id;
    },
    editingFormRef() {
      return ({ id }) => `absenseForm-${id}`;
    },
  },
  methods: {
    showComment(item) {
      return (
        item.visitTypeId === visitTypes.Ausencia ||
        item.visitTypeId ===
          visitTypes.Ausencia_Ofrecimiento_Reposicion_Ano_Anterior ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_AnoAnterior ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_Regresion ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_Reposicion ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento
      );
    },
    showDocument(item) {
      const value =
        item.visitTypeId === visitTypes.Ausencia &&
        item.absenceReasonId ===
          visitAbsenceTypes.AusenciaJustificadaDelEstudiante;

      if (this.editing(item))
        return Boolean(
          this.absenceModel.justification?.id ===
            visitAbsenceTypes.AusenciaJustificadaDelEstudiante
        );

      return value;
    },
    showJustified(item) {
      return (
        item.visitTypeId === visitTypes.Ausencia ||
        item.visitTypeId ===
          visitTypes.Ausencia_Ofrecimiento_Reposicion_Ano_Anterior ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_AnoAnterior ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_Regresion ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_Reposicion ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento
      );
    },
    showDateReplacement(item) {
      return (
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento ||
        item.visitTypeId === visitTypes.VisitaReposicion_AnoAnterior ||
        item.visitTypeId === visitTypes.VisitaReposicion
      );
    },
    isAbsenceOfReplacementYear(item) {
      return (
        item.visitTypeId ===
        visitTypes.Ausencia_Ofrecimiento_Reposicion_Ano_Anterior
      );
    },
    isAbsence(item) {
      return (
        item.visitTypeId === visitTypes.Ausencia ||
        item.visitTypeId ===
          visitTypes.Ausencia_Ofrecimiento_Reposicion_Ano_Anterior ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_AnoAnterior ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_Regresion ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento_Reposicion ||
        item.visitTypeId === visitTypes.Ausencia_Ofrecimiento
      );
    },
    isCyberTeraphy(item) {
      return item.visitTypeId === visitTypes.Visita_Ciberterapia;
    },
    formatDateLong(item) {
      if (item.visitDate === null) return;
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
      };
      const date = new Date(item.visitDate);
      let formatedDate = new Intl.DateTimeFormat('es-CL', options)
        .format(date)
        .toString();

      formatedDate = formatedDate[0].toUpperCase() + formatedDate.substring(1);
      return formatedDate;
    },
    formatDate(date) {
      if (date) {
        return moment(date)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
    },
    downloadDocument({ documentId }) {
      this.$emit('download-absence-document', documentId);
    },
    enableEdit(item) {
      this.absenceModel.id = item.id;
      this.absenceModel.type = {
        id: item.visitTypeId,
        name: item.visitTypeName,
      };
      this.absenceModel.comment = item.comment;
      const { id, name } = this.justificationOptions.find(
        (x) => x.id === item.absenceReasonId
      );
      this.absenceModel.justification = {
        id: id ?? item.absenceReasonId,
        name: name ?? item.absenceReasonName,
      };
      if (this.showDocument(item)) {
        this.absenceModel.document = {
          id: item.documentId,
          name: item.documentName,
        };
      }
    },
    disableEdit() {
      this.absenceModel = {
        id: null,
        type: null,
        justification: null,
        document: null,
        comment: null,
      };
    },
    quitDocumentSelected() {
      this.absenceModel.document = null;
    },
    async saveEdition(item) {
      const formRef = this.editingFormRef(item);
      const isValid = await this.$refs[formRef][0].validate();
      if (!isValid) return;

      this.$emit('save-edition', this.absenceModel);
    },
    visitName(item) {
      switch (item.visitTypeId) {
        case visitTypes.VisitaRegular:
          return 'Visita Regular Presencial';
        case visitTypes.Visita_Ciberterapia:
          return 'Visita Regular Ciberterapia';
        case visitTypes.Ausencia:
          return 'Ausencia';
      }
    },
    ediVisit(item) {
      this.$emit('edit-visit', item);
    },
  },
};
</script>

<style scoped>
.date-container {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  padding-right: 0;
}

.date {
  font-size: 15px;
  padding-left: 20px;
}
.success {
  font-size: 16px;
  padding-right: 0px;
}
.data-name {
  margin: 0;
}
.type-document {
  padding: 0;
}
#board {
  margin-bottom: 10px;
}
picture {
  margin-left: 13%;
}
.visit-errors {
  border: none !important;
}
</style>
